import { request } from "./api";

export const createRegistration = (payload) => request("POST", "/registrations", payload);
export const updateRegistration = (id, payload) => request("PUT", `/registrations/${id}`, payload);
